import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from '@ui/components/layout/Toaster';
import { ConfirmProvider } from '@ui/hooks/useConfirm';
import { store } from '@ui/store';
import { useMeQuery } from '@/store/orgApi';
import { router } from '@/router';
import './index.css';

/** Keeps the tab title on the platform's product name (set by the admin). */
function TitleSync() {
  const { data } = useMeQuery();
  useEffect(() => {
    if (data?.platform.appName) document.title = data.platform.appName;
  }, [data?.platform.appName]);
  return null;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <ConfirmProvider>
        <TitleSync />
        <RouterProvider router={router} />
        <Toaster />
      </ConfirmProvider>
    </Provider>
  </StrictMode>
);
